"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const nmr_processing_1 = require("nmr-processing");
const FormikInput_1 = __importDefault(require("../../../../elements/formik/FormikInput"));
const style = {
    input: {
        width: '50px',
        height: '26px',
    },
    inputWrapper: {
        borderWidth: 0,
        margin: '0 5px',
    },
};
function DeltaInput({ signal, index, onFocus }) {
    return ((0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)("span", { children: "\uD835\uDEC5: " }), (0, jsx_runtime_1.jsx)(FormikInput_1.default, { name: `signals.${index}.delta`, type: "number", placeholder: 'J (Hz)', onFocus: onFocus, style: style, checkErrorAfterInputTouched: false }), (0, jsx_runtime_1.jsx)("span", { children: signal.js
                    .map((_coupling) => (0, nmr_processing_1.translateMultiplet)(_coupling.multiplicity))
                    .join('') })] }));
}
exports.default = DeltaInput;
